// extracted by mini-css-extract-plugin
export default {"intoFormContainer":"JobInfoForm_intoFormContainer__YKJP1","modal-footer":"JobInfoForm_modal-footer__PX9YY","modal-cancel-button":"JobInfoForm_modal-cancel-button__GvJ9Q"};